
/* eslint-disable */
import axios from "axios";
const service = axios.create({
    baseURL: "/api",  // api的base_url
    timeout: 50000  // 请求超时时间
});

export const getApplyList = params=>{return service.post("/apply/apply_list",params);}
export const auditApplyToLine = params=>{return service.post("/line/addLine",params);}
export const auditApplyToEquip = params=>{return service.post("/equip/add_equip",params);}

export const indexImgList = params=>{return service.post("/index_img/img_list",params);}
export const indexImgUpdate = params=>{return service.post("/index_img/add_img",params);}

export const getLineList = params=>{return service.post("/route/list",params);}
export const visibleLine = params=>{return service.post("/route/update_state",params);}
export const addLine = params=>{return service.post("/route/modify",params);}
export const getLineById = params=>{return service.post("/route/get_by_id",params);}

export const getCityList = params=>{return service.post("/stand_city/list",params);}
export const getAllCityList = params=>{return service.post("/city/all_city_list",params);}
export const updateCityState = params=>{return service.post("/stand_city/update_state",params);}
export const addCity = params=>{return service.post("/stand_city/modify",params);}
export const getCityById = params=>{return service.post("/stand_city/get_by_id",params);}
export const getCityByName = params=>{return service.post("/city/get_city_byName",params);}

export const getUserList = params=>{return service.post("/customer/user_list",params);}

export const getNetworkList = params=>{return service.post("/network/list",params);}
export const visibleNetwork = params=>{return service.post("/network/update_state",params);}
export const getNetwork = params=>{return service.post("/network/get_by_id",params);}
export const addNetwork = params=>{return service.post("/network/modify",params);}

export const getArticleList = params=>{return service.post("/article/list",params);}
export const visibleArticle = params=>{return service.post("/article/update_state",params);}
export const getArticle = params=>{return service.post("/article/get_by_id",params);}
export const addArticle = params=>{return service.post("/article/modify",params);}

export const getGoodsList = params=>{return service.post("/goods/list",params);}
export const visibleGoods = params=>{return service.post("/goods/update_state",params);}
export const getGoods = params=>{return service.post("/goods/get_by_id",params);}
export const addGoods = params=>{return service.post("/goods/modify",params);}

export const getGoodsOrderList = params=>{return service.post("/goods_order/list",params);}
export const updateGoodsOrder = params=>{return service.post("/goods_order/update",params);}
export const getGoodsOrder = params=>{return service.post("/goods_order/get_by_id",params);}
export const visibleGoodsOrder = params=>{return service.post("/goods_order/update_state",params);}

export const getEmployList = params=>{return service.post("/employ/list",params);}
export const visibleEmploy = params=>{return service.post("/employ/update_state",params);}
export const getEmploy = params=>{return service.post("/employ/get_by_id",params);}
export const addEmploy = params=>{return service.post("/employ/modify",params);}



export const getFreeMarketList = params=>{return service.post("/free_market/list",params);}
export const visibleFreeMarket = params=>{return service.post("/free_market/update_state",params);}
export const getFreeMarket = params=>{return service.post("/free_market/get_by_id",params);}
export const addFreeMarket = params=>{return service.post("/free_market/modify",params);}

export const getJoinUsList = params=>{return service.post("/join_us/list",params);}
export const visibleJoinUs = params=>{return service.post("/join_us/update_state",params);}

export const getSuggestList = params=>{return service.post("/suggest/suggest_list",params);}
export const handlerSuggest = params=>{return service.post("/suggest/update_suggest",params);}
// export default service;

